import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {PropType} from "@vue/runtime-core";
import Multiselect from "@/Components/General/Multiselect.vue";
import {computed} from "vue";
import FaqCategory from "@/types/FaqCategory";


export default /*#__PURE__*/_defineComponent({
  __name: 'CategorySelect',
  props: {
  modelValue: {
    type: Number,
    default: () => null,
  },
  categories: {
    type: Object as PropType<FaqCategory[]>,
    default: () => [],
  },
  type: {
    type: String,
    default: () => "single",
  },
},
  emits: ["update:modelValue"],
  setup(__props, { emit }) {

const props = __props;




const value = computed({
  get(): any {
    return props.modelValue;
  },
  set(v: any) {
    emit("update:modelValue", v);
  },
});

const options = computed(() => {

  return props.categories.map((category: FaqCategory): object => {
    return category;
  });

});
const groups = computed(() => {

  return props.categories.map((category: FaqCategory): object => {
    return {
      label: category.title,
      options: category.sub_categories?.map((subCategory: FaqCategory): object => {
        return {
          label: subCategory.title,
          value: subCategory.id,
        };
      })
    }
  });

});



return (_ctx: any,_cache: any) => {
  return (__props.type==='single')
    ? (_openBlock(), _createBlock(Multiselect, {
        key: 0,
        searchable: true,
        modelValue: value.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
        options: options.value,
        placeholder: "Velg kategori",
        label: "title",
        valueProp: "id",
        class: "bg-white dark:bg-opacity-5",
        noResultsText: "Ingen treff",
        noOptionsText: "Ingen kategorier å vise"
      }, null, 8, ["modelValue", "options"]))
    : (__props.type==='test')
      ? (_openBlock(), _createBlock(Multiselect, {
          key: 1,
          modelValue: value.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value).value = $event)),
          "group-label": "label",
          class: "bg-white dark:bg-opacity-5",
          groupOptions: "options",
          "track-by": "value",
          valueProp: "value",
          label: "label",
          groupSelect: true,
          placeholder: "Velg kategori",
          groups: true,
          hideSelected: false,
          searchable: true,
          options: groups.value,
          "can-clear": true,
          closeOnSelect: true,
          noResultsText: "Ingen treff",
          noOptionsText: "Ingen kategorier å vise"
        }, null, 8, ["modelValue", "options"]))
      : _createCommentVNode("", true)
}
}

})